import type * as THREE from 'three';

/**
 * Original node name from the asset file, before THREE.PropertyBinding.sanitizeNodeName.
 * GLTFLoader stores the glTF node `name` on userData.name; FBXLoader sets userData.originalName.
 * When neither is present, returns object.name (already sanitized / no separate authoring name).
 */
export function sourceNameFromThreeBone(bone: THREE.Bone): string {
  const ud = bone.userData as Record<string, unknown>;
  const fbxOriginal = ud?.originalName;
  if (typeof fbxOriginal === 'string' && fbxOriginal.length > 0) {
    return fbxOriginal;
  }
  const gltfName = ud?.name;
  if (typeof gltfName === 'string' && gltfName.length > 0) {
    return gltfName;
  }
  return bone.name || '';
}
